
import { FieldControl } from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class PhoneWithPrefix extends SelectField {

    static PHONE_PREFIX_CODESC_VAR = 'Phone_Prefix';
    static MOBILE_PREFIX_CODESC_VAR = 'Mobile_Prefix';

    isMobile: boolean;

    constructor(attributes?: Object) {
        super(attributes);
        this.isMobile = attributes['controlType'] === FieldControl.MOBILE_WITH_PREFIX;
        this.dynamicOptions = true;
        this.codescVar = this.isMobile ? PhoneWithPrefix.MOBILE_PREFIX_CODESC_VAR : PhoneWithPrefix.PHONE_PREFIX_CODESC_VAR;

    }

}
